<template>
  <div class="downloads">
    <Hero
      class="hero"
      heading="Sales Material"
      :heroBackgroundImage="'sales-material.jpg'"
      :heroOverlay="'lightOverlay'"
    />
    <PageContainer>
      <div class="download-links">
        <h2 class="title">Case Studies</h2>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/case-studies/casebook.pdf"
        >
          Casebook may 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/case-studies/casebook.pptx"
        >
          Casebook may 2023 (ppt)
        </DownloadButton>
        <h2 class="title">Research Reports</h2>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/research-reports/lumen-research-overview.pdf"
        >
          Lumen Overview april 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/research-reports/lumen-research-overview.pptx"
        >
          Lumen Overview april 2023 (ppt)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/research-reports/lumen-research-one-pager.pdf"
        >
          Lumen 1-pager may 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/research-reports/lumen-research-one-pager.pptx"
        >
          Lumen 1-pager may 2023 (ppt)
        </DownloadButton>
        <h2 class="title">Creative Platform</h2>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/creative-platform/overview-six-pager.pdf"
        >
          Overview 6-pager feb 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/creative-specifications/seenThis-creative-platform-6-pager-(PPT).pptx"
        >
          Overview 6-pager feb 2023 (ppt)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/creative-platform/ad-tech-one-pager.pdf"
        >
          AdTech 1-pager feb 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/creative-specifications/seenThis-creative-platform-1-pager-adTech-(PPT).pptx"
        >
          AdTech 1-pager feb 2023 (ppt)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/creative-platform/advertiser-one-pager.pdf"
        >
          Advertiser-1 pager feb 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/creative-specifications/seenThis-creative-platform-1-pager-advertiser-(PPT).pptx"
        >
        Advertiser 1-pager feb 2023 (ppt)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/creative-platform/media-agency-one-pager.pdf"
        >
          Media Agency 1-pager feb 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/creative-specifications/seenThis-creative-platform-1-pager-media-agency-(PPT).pptx"
        >
          Media Agency 1-pager feb 2023 (ppt)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/creative-platform/publisher-one-pager.pdf"
        >
          Publisher 1-pager feb 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/creative-specifications/seenThis-creative-platform-1-pager-publisher-(PPT).pptx"
        >
          Publisher 1-pager feb 2023 (ppt)
        </DownloadButton>
        <h2 class="title">Creative Specifications</h2>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/creative-specifications/overview-five-pager.pdf"
        >
          Overview 5-pager march 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/creative-specifications/overview-five-pager-powerpoint.pptx"
        >
          Overview 5-pager march 2023 (ppt)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/creative-specifications/calculation-material-one-pager.pdf"
        >
          Calculation material 1-pager dec 2022 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/creative-specifications/existing-video-one-pager.pdf"
        >
          Existing video 1-pager feb 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/creative-specifications/image-drop-one-pager.pdf"
        >
          Image drop 1-pager april 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/creative-specifications/produce-your-own-ads-one-pager.pdf"
        >
          Produce your own ads 1-pager march 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/creative-specifications/production-assistance-one-pager.pdf"
        >
          Production assistance 1-pager feb 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/creative-specifications/takeovers-one-pager.pdf"
        >
          Takeovers 1-pager feb 2023 (pdf)
        </DownloadButton>
        <h2 class="title">Emissions Dashboard</h2>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/emissions-dashboard/emissions-dashboard-creative-platform-three-pager.pdf"
        >
          Creative Platform ED 3-pager april 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/emissions-dashboard/emissions-dashboard-creative-platform-three-pager.pptx"
        >
          Creative Platform ED 3-pager april 2023 (ppt)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/emissions-dashboard/emissions-dashboard-managed-service-three-pager.pdf"
        >
          Managed Service ED 3-pager april 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/emissions-dashboard/emissions-dashboard-managed-service-three-pager.pptx"
        >
          Managed Service ED 3-pager april 2023 (ppt)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/emissions-dashboard/emissions-dashboard-creative-platform-one-pager.pdf"
        >
          Creative Platform ED 1-pager april 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/emissions-dashboard/emissions-dashboard-creative-platform-one-pager.pptx"
        >
          Creative Platform ED 1-pager april 2023 (ppt)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/emissions-dashboard/emissions-dashboard-managed-service-one-pager.pdf"
        >
          Managed Service ED 1-pager april 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/emissions-dashboard/emissions-dashboard-managed-service-one-pager.pptx"
        >
          Managed Service ED 1-pager april 2023 (ppt)
        </DownloadButton>
        <h2 class="title">Product and Technology</h2>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/product-and-tech/segment-by-segment-five-pager.pdf"
        >
          Segment-by-segment 5-pager april 2023 (pdf)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/product-and-tech/segment-by-segment-five-pager.pptx"
        >
          Segment-by-segment 5-pager april 2023 (ppt)
        </DownloadButton>
        <DownloadButton
          class="btn"
          url="https://seenthis-brand.s3.amazonaws.com/download/sales-materials/product-and-tech/segment-by-segment-animated-four-pager.pptx"
        >
          Segment-by-segment Animated 4-pager april 2023 (ppt)
        </DownloadButton>
        <h2 class="title">Sustainability</h2>
        <DownloadButton
          class="btn"
          url="https://seenthis.co/information/sustainability/overview-two-pager.pdf"
        >
          Sustainability 2-pager dec 2022 (pdf)
        </DownloadButton>
      </div>
      <!-- ### This will be used as soon as the pdf:s are ready, don't delete. 2022-11-01 -->
      <!-- <div v-for="[category, items] in Object.entries(categories)" :key="category">
        <h2 class="title" v-text="category" />
        <div class="download-links">
          <DownloadButton
            v-for="item in items" class="btn"
            :key="item.filename" :url="item.filepath"
          >
            {{ item.title }}
          </DownloadButton>
        </div>
      </div> -->
    </PageContainer>
  </div>
</template>

<script>
import Hero from '../components/hero.vue';
import PageContainer from '../components/page-container.vue';
import DownloadButton from '../components/download-button.vue';

export default {
  name: 'Downloads',
  components: {
    Hero,
    PageContainer,
    DownloadButton,
  },
  data() {
    return {
      categories: {},
    };
  },
  mounted() {
    const rootUrl = 'https://seenthis-brand.s3.eu-west-1.amazonaws.com/download/sales-materials';
    const dataUrl = `${rootUrl}/index.csv?a=${+new Date()}`;
    fetch(dataUrl).then(res => res.text().then((data) => {
      const rows = data.split('\n');
      rows.shift();
      /* eslint-disable-next-line no-restricted-syntax */
      for (const row of rows) {
        const values = row.split(',');
        this.categories[values[0]] = this.categories[values[0]] || [];
        this.categories[values[0]].push({
          title: values[1],
          filename: values[2],
          filepath: `${rootUrl}/${values[2]}`,
        });
      }
      this.$forceUpdate();
    }));
  },
};
</script>


<style lang="stylus" scoped>
  @require '../style/colors'
  .comingSoon
    display: block
    margin: 8rem 0
    text-align: center

    p
      max-width: 70rem
      margin: 0 auto
      padding: 0 2rem
      font-size: 4rem
      color: $primary-color

      @media only screen and (max-width: 600px)
        font-size: 3rem
        padding: 3rem

  .hero
    margin-bottom: 30px
  h2
    font-weight: normal
    text-align: center
    margin: 60px 0 0 0
    font-size: 36px

  .download-links
    display: flex
    flex-direction: column
    padding: 0 60px
    max-width: 100rem
    justify-content: center
    margin: 0 auto 90px auto
  .btn
    margin-top: 20px

</style>
